import { useContext } from "react";
import { GnssApiContext } from "utils/providers";

export const useGnssApi = () => {
  return useContext(GnssApiContext);
};
